module.exports = __webpack_public_path__ + "img/burden-settings-icon.f9edebe1.svg";